import React from "react";
import { TypeOf } from 'zod';
import {Save} from "@mui/icons-material";
import { FormProvider, SubmitHandler, useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import {Button, Stack, Box, Badge,} from "@mui/material";
import useEntity from "../../../hooks/useUserSession";
import {PrimaryUserSession} from "../../../types/models/UserSession";
import {useGetUserSessionQuery} from "../../../apis/UserSession.api";
import UserSessionUpdateForm, {formSchema, initialFormStateFn} from "../../../components/userSession/UserSessionForm/UserSessionUpdateForm";
import { Trans } from "@lingui/react/macro";

export type FormInput = TypeOf<typeof formSchema>;

const UserSessionUpdateFormProvider = ({ id, initialFormState, cancelButton = undefined, redirectPath = undefined, successAction = undefined }) => {

    const primary = PrimaryUserSession.fromPath(id);
    const { data, isLoading } = useGetUserSessionQuery(primary)

    const methods = useForm<FormInput>({
        resolver: zodResolver(formSchema),
        defaultValues: initialFormState(data)
    });
    const {  updateUserSession } = useEntity();

    const {
        watch,
        reset,
        handleSubmit,
        formState: { isSubmitSuccessful, errors, },
    } = methods;

    React.useEffect(() => {
        if (data) {
            reset(data);
        }
    }, [data, reset]);

    
    const onSubmitHandler: SubmitHandler<FormInput> = async (values) => {
        const data = await updateUserSession({
            id: primary,
            data: values,
        }, redirectPath)
        if (data && successAction) {
            successAction(data)
        }
    };

    return (
        <>
            <FormProvider {...methods}>
                <Box
                    component='form'
                    onSubmit={
                        (e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            handleSubmit(onSubmitHandler)(e)
                        }
                    }
                    noValidate
                >

                    <UserSessionUpdateForm watch={watch}/>

                    <Stack direction="row" spacing={1} sx={{ justifyContent: "end", padding: 5 }}>

                        { cancelButton }

                        
                        <Badge badgeContent={Object.values(errors).length} color="error" anchorOrigin={ {vertical: 'bottom'} }>
                            <Button size="medium" variant="contained" color="primary" type='submit' startIcon={<Save />}>
                                <Trans>Update</Trans>
                            </Button>
                        </Badge>
                    </Stack>
                </Box>
            </FormProvider>
        </>
    )
}

export default UserSessionUpdateFormProvider
